import React from 'react'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import { useMyBookings } from '../hooks/useMyBookings'
import { extractResponse, reactGAEvent } from '../../../utils'

const useStyles = makeStyles((theme) => ({
    bookingBtn: {
        textTransform: 'none',
        width: '95%',
        [theme.breakpoints.up('sm')]: {
            width: 'max-content',
            position: 'static',
        },
    },
}))

export const CreateBookingButton = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const { data } = useMyBookings()

    if (data && extractResponse(data).success) {
        if (extractResponse(data).data.length === 0) {
            return null
        }
    }

    const onCreateBookingClicked = () => {
        reactGAEvent('Button', 'Create Booking button clicked')
        navigate('/create-booking')
    }

    return (
        <Button
            className={classes.bookingBtn}
            variant="contained"
            color="primary"
            size="medium"
            onClick={onCreateBookingClicked}
        >
            Create Booking
        </Button>
    )
}
